import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { usageTiersByProjectId } from "../graphql/queries";
import { UsageTiersByProjectIdQuery } from "../API";

export async function fetchLLMUsageTiers(
  projectId: string
): Promise<GraphQLResult<UsageTiersByProjectIdQuery>> {
  return API.graphql(
    graphqlOperation(usageTiersByProjectId, {
      projectId: projectId,
      limit: 100,
    })
  ) as Promise<GraphQLResult<UsageTiersByProjectIdQuery>>;
}
